function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13 1H3V3H1V12H15V3H13V1Z",
  fill: "#2038EC"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5 0H11V1H5V0Z",
  fill: "black"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M3 2V1H5V2H3Z",
  fill: "black"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M2 3V2H3V3H2Z",
  fill: "black"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M1 5V3H2V5H1Z",
  fill: "black"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14 3H15V5H14V3ZM15 5H16V16H15V14H1V16H0V5H1V12H15V5Z",
  fill: "black"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13 2V1H11V2H13ZM13 2H14V3H13V2Z",
  fill: "black"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M10 5H8V7H10V5Z",
  fill: "black"
});
var _ref0 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5 3V11H9V9H11V8H12V4H11V3H5ZM11 4V8H8V10H6V4H11Z",
  fill: "black"
});
var _ref1 = /*#__PURE__*/React.createElement("path", {
  d: "M5 2H6V3H5V2Z",
  fill: "white"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M4 3H3V4H2V8H3V4H4V3Z",
  fill: "white"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 4V10H8V8H11V4H6ZM10 5V7H8V5H10Z",
  fill: "white"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M15 16V14H1V16H15Z",
  fill: "white"
});
function SvgPow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref0, _ref1, _ref10, _ref11, _ref12);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPow);
export default __webpack_public_path__ + "static/media/pow.28ad5894395cb159361c69e2063fda2d.svg";
export { ForwardRef as ReactComponent };